module.exports = "/_next/static/images/freecharge-line-c2f7896bd3c5dd0ea8afc5ebb2c48ca8.svg";